import React, { forwardRef } from 'react'

import { IconProps } from './types'

const UserRemove = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.00001 13.4999L2.50221 13.4531L2.45081 13.9999H3.00001V13.4999ZM9.20775 9.48385L9.69168 9.60965L9.94334 8.64185L9.45948 8.51599L9.20775 9.48385ZM8.66668 13.9999H9.16668V12.9999H8.66668V13.9999ZM6.5409 8.51599L6.05699 8.64185L6.30869 9.60965L6.79261 9.48385L6.5409 8.51599ZM13.6869 11.0201L14.0405 10.6666L13.3333 9.95945L12.9798 10.3131L13.6869 11.0201ZM10.3131 12.9797L9.95954 13.3333L10.6667 14.0404L11.0202 13.6868L10.3131 12.9797ZM11.0202 10.3131L10.6667 9.95945L9.95954 10.6666L10.3131 11.0201L11.0202 10.3131ZM12.9798 13.6868L13.3333 14.0404L14.0405 13.3333L13.6869 12.9797L12.9798 13.6868ZM10 4.33325C10 5.43782 9.10461 6.33325 8.00001 6.33325V7.33325C9.65688 7.33325 11 5.99011 11 4.33325H10ZM8.00001 6.33325C6.89541 6.33325 6.00001 5.43782 6.00001 4.33325H5.00001C5.00001 5.99011 6.34316 7.33325 8.00001 7.33325V6.33325ZM6.00001 4.33325C6.00001 3.22869 6.89541 2.33325 8.00001 2.33325V1.33325C6.34316 1.33325 5.00001 2.6764 5.00001 4.33325H6.00001ZM8.00001 2.33325C9.10461 2.33325 10 3.22869 10 4.33325H11C11 2.6764 9.65688 1.33325 8.00001 1.33325V2.33325ZM3.49782 13.5467C3.71953 11.1883 5.44964 9.37672 7.91021 9.33405L7.89288 8.33419C4.87147 8.38659 2.76662 10.6405 2.50221 13.4531L3.49782 13.5467ZM7.91021 9.33405C7.94001 9.33352 7.96995 9.33325 8.00001 9.33325V8.33325C7.96421 8.33325 7.92848 8.33359 7.89288 8.33419L7.91021 9.33405ZM8.00001 9.33325C8.42815 9.33325 8.83175 9.38605 9.20775 9.48385L9.45948 8.51599C8.99908 8.39625 8.51081 8.33325 8.00001 8.33325V9.33325ZM3.00001 13.9999H8.66668V12.9999H3.00001V13.9999ZM7.89288 8.33419C7.42088 8.34239 6.96895 8.40472 6.5409 8.51599L6.79261 9.48385C7.14228 9.39285 7.51548 9.34085 7.91021 9.33405L7.89288 8.33419ZM12.9798 10.3131L11.6465 11.6464L12.3535 12.3535L13.6869 11.0201L12.9798 10.3131ZM11.6465 11.6464L10.3131 12.9797L11.0202 13.6868L12.3535 12.3535L11.6465 11.6464ZM10.3131 11.0201L11.6465 12.3535L12.3535 11.6464L11.0202 10.3131L10.3131 11.0201ZM11.6465 12.3535L12.9798 13.6868L13.6869 12.9797L12.3535 11.6464L11.6465 12.3535Z"
        fill={color}
      />
    </svg>
  ),
)

UserRemove.displayName = 'UserRemove'

UserRemove.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default UserRemove
